

// ======Scrolling Animation on Page============================

window.ScrollingBannerConfig = {
    speed: 120, // pixels per second
    //speed: 80, // pixels per second
    messages: [
        "🚀 Up to 70% OFF on all products – Limited Time Offer! 🚀",
        "📢 Promo! &nbsp Promo!! &nbsp Promo!!! &nbsp Hurry Up! 📢",
        // "🎉 Free shipping on orders over $50 🎉",
        "🕒 Hurry! Deals end midnight Sunday 🕒"
    ],
    position: "bottom", // or "top"
    fontSize: 20
};

let scrollBanner, scrollingText;

// let scrollBanner = document.getElementById("promoBanner");
// let scrollingText = document.getElementById("promoText");

let messageIndex = 0;

function showMessage(index) {
    scrollingText.innerHTML = ScrollingBannerConfig.messages[index];
    // scrollingText.innerText = ScrollingBannerConfig.messages[index];
    scrollMessage();
}

function scrollMessage() {
    const containerWidth = scrollBanner.offsetWidth;
    const textWidth = scrollingText.offsetWidth;
    let start = null;
    let currentX = containerWidth;

    function step(timestamp) {
        if (!start) start = timestamp;
        const elapsed = timestamp - start;
        currentX = containerWidth - (elapsed / 1000) * ScrollingBannerConfig.speed;

        if (currentX < -textWidth) {
            messageIndex = (messageIndex + 1) % ScrollingBannerConfig.messages.length;
            showMessage(messageIndex); // Rotate message
            return;
        }

        scrollingText.style.transform = `translateX(${currentX}px)`;
        scrollingText.dataset.paused !== "true" && requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
}

// Get Backend Messages and Replace FrontEnd
function loadBackendSiteAnnouncements() {

    console.log("loading banner")

    const el = document.getElementById('scrolling-banner-text');


    console.log("retrieved text content", el)

    // const el = document.getElementById('site-wide-banner-notice');
    // const el = document.querySelector('.site-wide-banner-notice');
    if (!el || !el.textContent.trim()) {
        console.log("no banner found")
        return [];
    }



    let siteBackendNotices = el.innerHTML

    // This only gets texts, no html elements
    // let siteBackendNotices = el.textContent

        .split('|')
        .map(item => item.trim()) // Replace &nbsp; with space, then trim
        // .map(item => item.replace(/\u00A0/g, ' ').trim()) // Replace &nbsp; with space, then trim
        .filter(item => item.length > 0); // Optional: remove empty items

    console.log("filtered banners")

    if (siteBackendNotices) {
        console.log("setting Config")
        ScrollingBannerConfig.messages = siteBackendNotices;
    }
}

export function InitScrollingBanner() {



    console.log("InitScroller Called")

    // Check if Announcement, if not don't render
    loadBackendSiteAnnouncements();


    // Get the Announcement Div, and Check Content, if empty or not available, return
    if (ScrollingBannerConfig.messages.length < 1) {
        console.log("no mesage, returning")
        return false;
    }

    //  Set Up Elements
    scrollBanner = document.getElementById("scrolling-banner");
    scrollingText = document.getElementById("scrolling-banner-text");


    if (scrollBanner !== null) {

        // Positioning
        scrollBanner.style[ScrollingBannerConfig.position] = "0";
        scrollBanner.style.fontSize = ScrollingBannerConfig.fontSize + "px";

        console.log("banner found")

        // Pause on hover (desktop only)
        scrollBanner.addEventListener("mouseenter", () => {
            scrollingText.dataset.paused = "true";
        });
        scrollBanner.addEventListener("mouseleave", () => {
            scrollingText.dataset.paused = "false";
            scrollMessage();
        });

        console.log("calling show Messages")

        showMessage(0);

        // Function Already called in Windows load event

        // window.addEventListener("load", () => {
        //     loadBackendMessages();
        //     showMessage(0);
        // });
    }


}



// Configured from Database
// "🚀 Up to 70% OFF on all products – Limited Time Offer! 🚀 | 📢 Promo! &nbsp Promo!! &nbsp Promo!!! &nbsp Hurry Up! 📢 | 🎉 Free shipping on orders over $50 🎉 | 🕒 Hurry! Deals end midnight Sunday 🕒 | ⏳Time is Running Out, Don't Miss⏳"